/*
*
* File JS per l'archivio blog
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import cardBlog from '../../components/card-blog/card-blog.js';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './blog-archive.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{
    cardBlog();
});

//--------------------------------------------------------------------//